import React from "react";
import "./Equipe.css";

// Import das imagens da equipe
import fernandaImg from "../../assets/img/equipe/fernanda.jpg";
import juliaImg from "../../assets/img/equipe/julia.jpg";
import lorenaImg from "../../assets/img/equipe/lorena.jpg";

export default function SecaoEquipe() {
  return (
    <section className="equipe-wrapper py-5" id="equipe">
  <div className="container text-center">
    <h2 className="titulo-secao scroll-reveal-zoom">
      Conheça nossa Equipe
      <span className="barra"></span>
    </h2>
    <p className="mb-5 scroll-reveal-zoom">
      Parcerias que transformam resultados. O sucesso dos nossos clientes é o nosso sucesso.
    </p>

    <div className="row g-4 justify-content-center">
      {/* Fernanda */}
      <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
        <div className="card h-100 card-equipe">
          <img src={fernandaImg} alt="Fernanda Pantojo" className="card-img-top equipe-foto" />
          <div className="card-body">
            <h5 className="card-title">Fernanda Pantojo</h5>
            <p className="cargo">Responsável pelo Setor Comercial</p>
            <p className="card-text">
              Engenheira Ambiental e Sanitarista<br />
              Engenheira de Segurança do Trabalho
            </p>
          </div>
        </div>
      </div>

      {/* Júlia */}
      <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
        <div className="card h-100 card-equipe">
          <img src={juliaImg} alt="Júlia Koury" className="card-img-top equipe-foto" />
          <div className="card-body">
            <h5 className="card-title">Júlia Koury</h5>
            <p className="cargo">Responsável pelo Setor Financeiro e Compliance</p>
            <p className="card-text">Engenheira Ambiental</p>
          </div>
        </div>
      </div>

      {/* Lorena */}
      <div className="col-12 col-md-6 col-lg-4 scroll-reveal-zoom">
        <div className="card h-100 card-equipe">
          <img src={lorenaImg} alt="Lorena Gotelip Costalonga" className="card-img-top equipe-foto" />
          <div className="card-body">
            <h5 className="card-title">Lorena Gotelip Costalonga</h5>
            <p className="cargo">Responsável pelo Setor Operacional</p>
            <p className="card-text">
              Engenheira Ambiental e Sanitarista<br />
              Especialista em SGI de Meio Ambiente<br />
              Qualidade e Segurança do Trabalho<br/>
              Pós-graduanda em Especialização em Engenharia Geotécnica 
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  );
}
